import React, {useState} from "react";
import {View, StyleSheet, TouchableOpacity} from "react-native";
import PtText from "../core/pt-text/pt-text";
import {styleVars} from "../../app-style-vars";
import PtIcon from "../core/pt-icon/pt-icon";
import {getTranslation} from "../../helpers/getTranslation";
import PtDuePaymentStatusIndicator from "./pt-due-payment-status-indicator";
import PtBankSlip from "./pt-bank-slip";


export default function PtDuePaymentSingle(props:any) {

  const dueDateLabel = props.dueDateLabel || getTranslation('due.payments.due.date.label') || 'Due date';
  const salesPartnerLabel = props.salesPartnerLabel || getTranslation('due.payments.sales.partner.label') || 'Sales Partner';
  const salesPartnerMissingLabel = props.salesPartnerMissingLabel || getTranslation('due.payments.sales.partner.missing.label') || 'Not Available';
  const paymentConditionLabel = props.paymentConditionLabel || getTranslation('due.payments.payment.condition.label') || 'Payment condition';
  const paymentConditionMissingLabel = props.paymentConditionMissingLabel || getTranslation('due.payments.payment.condition.missing.label') || 'unknown';
  const issueDateLabel = props.issueDateLabel || getTranslation('due.payments.issue.date.label') || 'Issue date';
  const bankKeyLabel = props.bankKeyLabel || getTranslation('due.payments.bank.key.label') || 'Bank key';

  const duePayment = props.duePayment;

  const [showDetails, setShowDetails] = useState(false);

  const toggleDetails = () => {
    setShowDetails(!showDetails);
  }


  return (
    <View style={[styles.duePaymentContainer]}>
      <TouchableOpacity onPress={() => toggleDetails()}>
        <View style={[styles.duePaymentHeaderContainer]}>
          <View style={[styles.openIndicator]}>
            <PtIcon iconName={showDetails ? 'less-minimize' : 'add'} iconSize={24} iconColor={styleVars.boschDarkBlue}/>
          </View>
          <View style={[styles.headerDataContainer]}>
            <View style={[styles.headerDataColumn, styles.headerDataColumnLeft]}>
              <PtText style={[styles.headerDataValueText, styles.invoiceNumberText]}>{duePayment.invoice}</PtText>
              <PtText style={[styles.headerDataValueText]}>{duePayment.installment}</PtText>
              <PtText style={[styles.headerDataValueText]}>{duePayment.entryType}</PtText>
            </View>
            <View style={[styles.headerDataColumn, styles.headerDataColumnMiddle]}>
              <PtText style={[styles.headerDataValueText]}>{dueDateLabel}</PtText>
              <PtText style={[styles.headerDataValueText]}>{duePayment.due}</PtText>
              <PtText style={[styles.headerDataValueText]}>{duePayment.amountDisplay}</PtText>
            </View>
            <View style={[styles.headerDataColumn, styles.headerDataColumnRight]}>
              <PtDuePaymentStatusIndicator statusCode={duePayment.status} statusText={duePayment.statusDisplay}/>
            </View>
          </View>
        </View>
      </TouchableOpacity>
      {showDetails ?
        <View style={[styles.duePaymentDetailsContainer]}>
          <View style={[styles.duePaymentDetailsContentContainer]}>
            <View style={[styles.detailContainer]}>
              <View style={[styles.detailLabelContainer]}>
                <PtText style={[styles.detailLabel]}>{salesPartnerLabel}</PtText>
              </View>
              <View style={[styles.detailValueContainer]}>
                <PtText style={[styles.detailValue]}>{duePayment.partner ? duePayment.partner : salesPartnerMissingLabel}</PtText>
              </View>
            </View>
            <View style={[styles.detailContainer]}>
              <View style={[styles.detailLabelContainer]}>
                <PtText style={[styles.detailLabel]}>{paymentConditionLabel}</PtText>
              </View>
              <View style={[styles.detailValueContainer]}>
                <PtText style={[styles.detailValue]}>{duePayment.paymentTerml? duePayment.paymentTerml : paymentConditionMissingLabel}</PtText>
              </View>
            </View>
            <View style={[styles.detailContainer]}>
              <View style={[styles.detailLabelContainer]}>
                <PtText style={[styles.detailLabel]}>{issueDateLabel}</PtText>
              </View>
              <View style={[styles.detailValueContainer]}>
                <PtText style={[styles.detailValue]}>{duePayment.issueDate}</PtText>
              </View>
            </View>
            <View style={[styles.detailContainer]}>
              <View style={[styles.detailLabelContainer]}>
                <PtText style={[styles.detailLabel]}>{bankKeyLabel}</PtText>
              </View>
              <View style={[styles.detailValueContainer]}>
                <PtText style={[styles.detailValue]}>{duePayment.bankKey}</PtText>
                <PtText style={[styles.detailValue]}>{duePayment.bankDisplay}</PtText>
                <View style={[styles.bankSlipPrintContainer]}>
                  <PtBankSlip payment={duePayment}/>
                </View>
              </View>
            </View>
          </View>
        </View>
        : null
      }
    </View>
  )
}

const styles = StyleSheet.create({
  duePaymentContainer: {
    paddingVertical: styleVars.rem(.5),
    borderBottomWidth: 1,
    borderBottomColor: styleVars.boschLightGray,
    zIndex: 1,
  },
  duePaymentHeaderContainer: {
    paddingLeft: styleVars.rem(2.5),
  },
  openIndicator: {
    position: 'absolute',
    top: styleVars.rem(.5),
    left: styleVars.rem(.5),
    width: styleVars.rem(1.5),
    height: styleVars.rem(1.5),
  },
  headerDataContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  headerDataColumn: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    overflow: 'hidden',
    marginHorizontal: styleVars.rem(.5),
  },
  headerDataColumnLeft: {
    justifyContent: 'space-between',
  },
  headerDataColumnMiddle: {
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  headerDataColumnRight: {
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
  },
  headerDataValueText: {
    fontSize: styleVars.rem(.875),
    width: '100%',
  },
  invoiceNumberText: {
    color: styleVars.boschDarkBlue
  },
  duePaymentDetailsContainer: {
    marginVertical: styleVars.rem(.5),
    paddingLeft: styleVars.rem(2.5),
    paddingRight: styleVars.rem(.5)
  },
  duePaymentDetailsContentContainer: {
    backgroundColor: styleVars.boschLightGrayW75,
    paddingHorizontal: styleVars.rem(1)
  },
  detailContainer: {
    paddingVertical: styleVars.rem(.5),
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  detailLabelContainer: {
    maxWidth: '50%',
    justifyContent: 'flex-start',
  },
  detailValueContainer: {
    maxWidth: '50%',
    justifyContent: 'center',
    alignItems: 'flex-end'
  },
  detailLabel: {
    textAlign: 'left',
    fontWeight: '600'
  },
  detailValue: {
    textAlign: 'right'
  },
  bankSlipPrintContainer: {
  }
})